import { ImgixImage } from '@components/gassan-ui'
import { cn } from '@lib/cn'
import { FC, HTMLAttributes, useEffect, useRef } from 'react'

type Props = {
  isActive: boolean
  src: string
  variant?: 'default' | 'fullscreen'
  title: string
} & Omit<HTMLAttributes<HTMLDivElement>, 'onLoad' | 'placeholder'>

const Slide: FC<Props> = ({ isActive, src, variant = 'default', title, onClick, ...rest }) => {
  const hasBeenActive = useRef(false)
  useEffect(() => {
    if (isActive && !hasBeenActive.current) {
      hasBeenActive.current = true
    }
  }, [isActive])

  return (
    <div onClick={onClick}>
      <ImgixImage
        alt={title}
        src={src}
        className={cn(
          'absolute left-0 top-0 h-full w-full bg-shade-50 transition-opacity duration-300',
          isActive ? 'opacity-100' : 'opacity-0',
          variant === 'default' && 'cursor-zoom-in',
        )}
        imgClassName="object-contain"
        {...rest}
      />
    </div>
  )
}

export default Slide
